import React, {useEffect} from 'react';
import {Route, Switch, useRouteMatch} from 'react-router';
import useDispatchWithResult from '../../../../hooks/useDispatchWithResult';
import {fetchLivroDigital} from '../../../../store/empresa';
import EmpresaLivroDigitalCreatePage from './_create';
import EmpresaLivroDigitalDetailPage from './_detail';
import EmpresaLivroDigitalEditPage from './_edit';

export default function EmpresaLivroDigitalPage() {
  const dispatch = useDispatchWithResult();
  const match = useRouteMatch();
  const empresaId = match.params.empresaId;
  const id = match.params.id;

  useEffect(() => {
    dispatch(fetchLivroDigital({empresaId, id}));
  }, [empresaId, id]);

  return (
      <Switch>
        <Route path="/*/empresas/:empresaId/livros-digitais/:id/edit" component={EmpresaLivroDigitalEditPage} />
        <Route path="/*/empresas/:empresaId/livros-digitais/create" component={EmpresaLivroDigitalCreatePage} />
        <Route path="/*/empresas/:empresaId/livros-digitais/:id" component={EmpresaLivroDigitalDetailPage} />
      </Switch>);
}
